import jwtDecode from "jwt-decode";
import Config from "../../service/auth/config.js";

export default class Token extends Config {

  /** decodificando jwt do cookie **/
  decodeToken(tokenParam) {
    let payLoad = jwtDecode(this.getCookie(tokenParam));
    return payLoad;
  }

  getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      let [key, value] = cookie.split("=");
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  getLocal() {
    try {
      // Obtém o valor do cookie e substitui "+" por espaço
      let local = this.getCookie("local").replaceAll("+", " ");

      if (!local) {
        console.warn("Cookie 'local' está vazio ou não encontrado.");
        return;
      }
      // Converte a string para um formato JSON válido
      const jsonStr = local
        .replace(/^\[|\]$/g, "") // Remove colchetes externos
        .replace(/(\w+)=/g, '"$1":') // Adiciona aspas às chaves e substitui "=" por ":"
        .replace(/:\s?([^",{}\d]+)/g, ': "$1"'); // Adiciona aspas em valores de texto

      // Converte para objeto JSON
      const jsonObj = JSON.parse(`[${jsonStr}]`);

      // Armazena no estado
      return jsonObj[0] || null;

    } catch (error) {
      console.error("Erro ao converter o cookie 'local' para JSON:", error);
    }
  }

  isTokenExpired(expirationTimestamp) {

    // DATA E HORA QUE VAI EXPIRAR 
    const timestampS = this.decodeToken('access_token').exp; // Em segundos
    /* SE MANDAR ALGO */
    if (expirationTimestamp) {
      const currentTime = Math.floor(Date.now() / 1000);
      return currentTime >= expirationTimestamp;
    } else {
      expirationTimestamp = timestampS;
      const currentTime = Math.floor(Date.now() / 1000);
      return currentTime >= expirationTimestamp;
    }
  }
}
